import type { ActionInput } from "../ActionInput.js";
import {
  formIsAutoClosed,
  hasBeenAnonymised,
  isCurrentUserSupervisor,
  triageSelectionIsSection136,
} from "../helpers.js";

export function calculatePdfActions(actionInput: ActionInput) {
  const isASection136 = triageSelectionIsSection136(actionInput);

  const anonymiserHasRun =
    hasBeenAnonymised(actionInput) || formIsAutoClosed(actionInput);

  const hasStoredCopy =
    actionInput.incidentWorkItem.incidentWorkItem.pdfUri !== null;

  return {
    canView: isASection136,
    canDownload: isASection136 && !anonymiserHasRun && hasStoredCopy,
    canDownloadAsSupervisor:
      isCurrentUserSupervisor(actionInput.user) &&
      isASection136 &&
      !anonymiserHasRun,
  };
}
